module.exports = __webpack_public_path__ + "2c428c5a4b110b17c3bc6d2e130f79ba.png";